// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * The one line of substance a lineage node carries beyond its label, for the
 * Details column of the audit-lineage table and its exports.
 *
 * A tool-call node's whole content is what the tool returned
 * (`result_summary`); the table showed only "Tool: <name>" and an id, so an
 * auditor reading a chat's tool calls could not see what any of them did. A
 * workflow run and a task carry their status. Other node kinds are fully
 * described by their label, and this returns an empty string for them.
 */
export function lineageNodeDetail(node) {
    const meta = node.metadata;
    switch (meta.kind) {
        case 'tool_call':
            return meta.result_summary ?? '';
        case 'workflow_run':
            return meta.status ?? '';
        case 'task':
            return meta.task_status ?? '';
        default:
            return '';
    }
}
//# sourceMappingURL=lineage-node-detail.js.map